import { useSourceSuggestionKeywordsVariation } from '#pplx/frontend/apps/ask/generated/assignment-hooks/useSourceSuggestionKeywordsVariation.js';
import { useMemo } from 'react';
const DEFAULT_VALUE = {};
export const useSourceSuggestionKeywords = () => {
    const { variation } = useSourceSuggestionKeywordsVariation({ defaultValue: DEFAULT_VALUE });
    const keywords = useMemo(() => {
        const response = new Map();
        Object.entries(variation).forEach(([source, keywords]) => {
            keywords.forEach((keyword) => {
                const sources = response.get(keyword) || [];
                sources.push(source);
                response.set(keyword, sources);
            });
        });
        return response;
    }, [variation]);
    return useMemo(() => ({ keywords }), [keywords]);
};
//# sourceMappingURL=useSourceSuggestionKeywords.js.map